import { render } from "./ActivateGtrBasic.vue?vue&type=template&id=4ac08f07&ts=true"
import script from "./ActivateGtrBasic.vue?vue&type=script&lang=ts"
export * from "./ActivateGtrBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__